

const state = {
    sliderPositon: 0
}

const getters = {
    getSliderPosition: state => {
        return state.sliderPositon
    }
}

const actions = {
    increment (context) {
        context.commit('increment')
    },
    decrement (context) {
        context.commit('decrement')
    }
}

const mutations = {
    increment(state) {
        if (state.sliderPositon !== 5) {
            state.sliderPositon++
        }
        else {
            state.sliderPositon = 0
        }
    },

    decrement(state) {
        if (state.sliderPositon === 0) {
            state.sliderPositon = 5
        }
        else {
            state.sliderPositon--
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/testimonies.js